import React from 'react';
import { analytics } from '../../utils/analytics';

interface IntentionModalProps {
  isOpen: boolean;
  intention: string;
  onIntentionChange: (intention: string) => void;
  onClose: () => void;
}

export const IntentionModal: React.FC<IntentionModalProps> = ({
  isOpen,
  intention,
  onIntentionChange,
  onClose
}) => {
  const handleSave = () => {
    if (intention.trim()) {
      analytics.intentionSet();
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full transition-colors duration-300">
        <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">Set Your Intention</h3>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          What intention would you like to carry through your 54-day novena?
        </p>
        <textarea
          value={intention}
          onChange={(e) => onIntentionChange(e.target.value)}
          placeholder="Enter your prayer intention..."
          className="w-full border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 rounded-lg p-3 mb-4 resize-none focus:border-indigo-600 dark:focus:border-indigo-500 focus:ring-2 focus:ring-indigo-600/20 transition-all duration-200"
          rows={3}
        />
        <div className="flex gap-3">
          <button
            onClick={handleSave}
            className="flex-1 bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 text-white py-2 px-4 rounded-lg font-semibold transition-colors"
          >
            Begin Novena
          </button>
        </div>
      </div>
    </div>
  );
};